export function useFormValidation(
   formState,
   setIsInvalid,
   isInvalidIf,
   shouldValidate = true
) {
   const [formData, setFormData] = formState

   function setValue(event) {
      const { name, value } = event?.target
      if (shouldValidate) {
         isFieldInvalid(name, value)
      }
      setFormData(prevFormData => ({
         ...prevFormData,
         [name]: value
      }))
   }

   function isFieldInvalid(field, value) {
      const isInvalidIfFunction =
         field in isInvalidIf ? isInvalidIf[field] : () => false
      const isFieldInvalid = isInvalidIfFunction(value)
      setIsInvalid(prev => ({
         ...prev,
         [field]: isFieldInvalid
      }))
      return isFieldInvalid
   }

   function isAnyFieldInvalid() {
      let isAnyFieldInvalid = false
      Object.keys(formData).forEach(name => {
         const value = formData[name]
         const isCurrentFieldInvalid = isFieldInvalid(name, value)
         isAnyFieldInvalid = isAnyFieldInvalid || isCurrentFieldInvalid
      })
      return isAnyFieldInvalid
   }

   return {
      setValue,
      isAnyFieldInvalid
   }
}
